import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Styles from './DonationButtonStrip.styles';

import DonationButton from '../../base/DonationButton';

const ContainerStrip = styled.div`
  ${Styles.container};
`;

/**
 * DonationButton component
 * @property {Object} props - component props
 * @returns {JSX}
 */
class DonationButtonStrip extends React.PureComponent {
  /**
   * Constructor method
   * @param {Object} props - component props
   */
  constructor(props) {
    super(props);
    this.updateAmountSelected = this.updateAmountSelected.bind(this);
    this.amounts = props.amounts;
    this.initialState = {
      selectedAmount: props.defaultSelectedAmount
    };
    this.state = this.initialState;
  }

  /**
   * updateAmountSelected Updates and notifies changes on selected amount
   * @param {Object} event - event with amount selected
   */
  updateAmountSelected(event) {
    const newAmount = parseInt(event.target.value, 10);
    const { onDonationChange } = this.props;
    const { selectedAmount } = this.state;
    let updatedAmount = newAmount;
    if (selectedAmount === newAmount) {
      updatedAmount = null;
    }
    this.setState({
      selectedAmount: updatedAmount
    }, () => {
      onDonationChange(updatedAmount);
    });
  };

  /**
   * Render method
   * @returns {JSX}
   */
  render() {
    const { selectedAmount } = this.state;
    return (
      <ContainerStrip>
        {
          this.amounts.map((amount) => {
            return (
              <DonationButton
                amount={amount}
                selected={amount === selectedAmount}
                key={`donation-amount-${amount}`}
                onClick={this.updateAmountSelected}
              />
            );
          })
        }
      </ContainerStrip>
    );
  };
};

DonationButtonStrip.propTypes = {
  onDonationChange: PropTypes.func,
  amounts: PropTypes.arrayOf(PropTypes.number),
  defaultSelectedAmount: PropTypes.number
};

DonationButtonStrip.defaultProps = {
  onDonationChange: () => {},
  amounts: [1, 3, 5],
};

export default DonationButtonStrip;
